var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup169White(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_169",
    "data-name": "Group 169",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.065,
    height: 33.06,
    viewBox: "0 0 33.065 33.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3460",
    "data-name": "Path 3460",
    d: "M-447,193.788q0-4.887,0-9.774a3.7,3.7,0,0,1,3.955-3.955h19.635a3.7,3.7,0,0,1,3.955,3.954q0,9.818,0,19.635a3.7,3.7,0,0,1-3.955,3.956q-9.839,0-19.678,0A3.7,3.7,0,0,1-447,203.691Q-447,198.74-447,193.788Zm13.772-10.989q-4.758,0-9.516,0a1.382,1.382,0,0,0-1.515,1.525q0,9.495,0,18.99a1.4,1.4,0,0,0,1.536,1.549h18.99a1.392,1.392,0,0,0,1.538-1.548q0-9.473,0-18.947a1.4,1.4,0,0,0-1.559-1.569Z",
    transform: "translate(452.52 -174.545)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3461",
    "data-name": "Path 3461",
    d: "M-506.948,143.56a3.684,3.684,0,0,1-4.113-3.593c-.024-1.363-.006-2.727-.006-4.09q0-7.943,0-15.887a3.7,3.7,0,0,1,3.924-3.942q9.9,0,19.8,0a3.7,3.7,0,0,1,3.8,4.117h-19.777a3.448,3.448,0,0,0-3.63,3.611q0,9.623,0,19.245Z",
    transform: "translate(511.073 -116.047)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3462",
    "data-name": "Path 3462",
    d: "M-381.01,266.633a3.894,3.894,0,0,1,.333-.477q3.829-3.839,7.666-7.67a1.908,1.908,0,0,1,2.337-.518,2.278,2.278,0,0,1,1.413,2.334,2.4,2.4,0,0,1-.575,1.16q-4.884,4.944-9.819,9.837a1.908,1.908,0,0,1-2.836-.025q-1.447-1.443-2.865-2.914a1.931,1.931,0,0,1,0-2.779,2.042,2.042,0,0,1,2.159-.811,2.576,2.576,0,0,1,.947.55C-381.836,265.689-381.483,266.125-381.01,266.633Z",
    transform: "translate(396.724 -245.553)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup169White);
export default __webpack_public_path__ + "static/media/Group 169 white.f4a09e4bc58672341c449233c3c69dc1.svg";
export { ForwardRef as ReactComponent };